<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Audit - Vehicle/Propulsion Volume Comparison</h1>
  </div>
  <div>
    <button mat-flat-button color="primary" id="report-button" class="action-button"
            (click)="getReport()" [disabled]="selectedScenarios?.length === 0">
      Run Report
    </button>
  </div>
</div>
<div class="d-flex flex-row ps-2 pe-2 gap-16 content-height">
  <div class="d-flex flex-column gap-8">
    <h3>Filter By:</h3>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Region</mat-label>
      <fab-multiselect
        [disabled]="selectedScenarioType === 1 || regionOptions.options.length === 0"
        [(ngModel)]="regionOptions.selectedOptions"
        (ngModelChange)="onFilterChange(REGION)"
        [options]="regionOptions.options">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Subregion</mat-label>
      <fab-multiselect
        [options]="subregionOptions.options"
        [(ngModel)]="subregionOptions.selectedOptions"
        (ngModelChange)="onFilterChange(SUBREGION)"
        [disabled]="selectedScenarioType === 1 || subregionOptions.options.length === 0">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Planning Market</mat-label>
      <fab-multiselect
        [disabled]="selectedScenarioType === 1 || plngMktOptions.options.length === 0"
        [(ngModel)]="plngMktOptions.selectedOptions"
        (ngModelChange)="onFilterChange(PLNGMKT)"
        [options]="plngMktOptions.options">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Market Division</mat-label>
      <fab-multiselect
        [disabled]="selectedScenarioType === 1 || mktDivOptions.options.length === 0"
        [(ngModel)]="mktDivOptions.selectedOptions"
        (ngModelChange)="onFilterChange(MKTDIV)"
        [options]="mktDivOptions.options">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Architecture</mat-label>
      <fab-multiselect
        [disabled]="selectedScenarioType === 1 || archOptions.options.length === 0"
        [(ngModel)]="archOptions.selectedOptions"
        (ngModelChange)="onFilterChange(ARCH)"
        [options]="archOptions.options">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Program Code</mat-label>
      <fab-multiselect
        [disabled]="selectedScenarioType === 1 || prgmCodeOptions.options.length === 0"
        [(ngModel)]="prgmCodeOptions.selectedOptions"
        (ngModelChange)="onFilterChange(PRGMCODE)"
        [options]="prgmCodeOptions.options">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Brandfam</mat-label>
      <fab-multiselect
        [disabled]="selectedScenarioType === 1 || brandfamOptions.options.length === 0"
        [(ngModel)]="brandfamOptions.selectedOptions"
        (ngModelChange)="onFilterChange(BRANDFAM)"
        [options]="brandfamOptions.options">
      </fab-multiselect>
    </mat-form-field>
    <div class="year-container d-flex flex-row gap-8">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Start Year</mat-label>
        <mat-select [(ngModel)]="startYear" id="startYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>End Year</mat-label>
        <mat-select [(ngModel)]="endYear" id="endYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="d-flex flex-column gap-8 flex-grow-1">
    <div class="d-flex flex-column justify-content-center">
      <mat-button-toggle-group [(ngModel)]="selectedScenarioType"
                               hideSingleSelectionIndicator="true"
                               (ngModelChange)="onSourceChange()">
        <mat-button-toggle id="forecast-org-toggle" [value]="0" class="equal-flex-item">
          By Forecast Org
        </mat-button-toggle>
        <mat-button-toggle id="global-scenario-toggle" [value]="1" class="equal-flex-item">
          By Global Scenario
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="mh-100 h-100">
      <app-vehicle-scenario-select
        titleText="Select Vehicle Scenario"
        [isMultiSelect]="false"
        (confirmEvent)="selectScenario($event)"
        *ngIf="selectedScenarioType === 0">
      </app-vehicle-scenario-select>
      <app-global-scenario-select-component
        [memberScenarioType]="0"
        [filterNonGM]="false"
        [user]="stateService.getUserGmid()"
        (confirmEvent)="selectGlobalScenario($event)"
        *ngIf="selectedScenarioType === 1"></app-global-scenario-select-component>
    </div>
  </div>
</div>
